import * as AppConstants from "AppConstants";

export const getUrlForManagerByUserId = (userId) => {
    const url = AppConstants.GET_MANAGER_BY_USER_ID_ENDPOINT
                    .replace(AppConstants.USER_ID_PLACEHOLDER, userId);
    return url;
}

export const getUrlForMembersForManager = (managerId) => {
    const url = AppConstants.GET_MEMBERS_FOR_MANAGER_ENDPOINT
                    .replace(AppConstants.MANAGER_ID_PLACEHOLDER, managerId);
    return url;
}

export const getUrlToFetchAllManagers = () => {
    const url = AppConstants.GET_ALL_MANAGERS;
    return url;
}

/**
 * Builds the server-paginated managers URL with page/sort/search query params.
 * GET /v1/api/managers/all/paged?pageNumber=&pageSize=&sortBy=&sortDirection=&searchQuery=
 */
export const getUrlForManagersPage = ({ page, pageSize, sortBy, sortDirection, searchQuery }) => {
    const params = new URLSearchParams({
        pageNumber: String(page ?? 0),
        pageSize: String(pageSize ?? 10),
        sortBy: sortBy ?? "name",
        sortDirection: sortDirection ?? "ASC",
    });
    if (searchQuery) params.append("searchQuery", searchQuery);
    return `${AppConstants.GET_MANAGERS_PAGED_ENDPOINT}?${params.toString()}`;
}

export const getUrlToApproveActivites = () => {
    const url = AppConstants.GET_ACTIVITY_APPROVAL_ENDPOINT+'?status=APPROVED';
    return url;
}
export const getUrlToRejectActivites = () => {
    const url = AppConstants.GET_ACTIVITY_APPROVAL_ENDPOINT+'?status=SUBMITTED';
    return url;
}
// Marks approved rows (activities, holidays, leave) as APPROVED_BY_CLIENT — a frozen
// financial record. Reuses the generic /approval endpoint with the client-approval status.
// @since NEXT_VERSION
export const getUrlToClientApproveActivites = () => {
    const url = AppConstants.GET_ACTIVITY_APPROVAL_ENDPOINT+'?status=APPROVED_BY_CLIENT';
    return url;
}

// In dev, MEMBER_API_HOST is '/api' and setupProxy.js rewrites ^/api/hierarchy -> /v1/api/hierarchy
// (member-management). Match the bare-resource convention used by the other endpoints above.
export const getUrlForEligibleParents = (managerId) =>
    `${AppConstants.MEMBER_API_HOST}/hierarchy/eligible-parents?managerId=${managerId}`;

// Same picker for the Create Manager form, where the manager has no id yet, so the candidate
// set is keyed on the chosen user instead. @since NEXT_VERSION
export const getUrlForEligibleParentsByUser = (userId) =>
    `${AppConstants.MEMBER_API_HOST}/hierarchy/eligible-parents?userId=${userId}`;

// Managers in the logged-in manager's subtree (self + L1 children). Same /api/hierarchy proxy
// route as eligible-parents; drives the L2 report-filter and Add-dialog dropdowns.
export const getUrlForScopeManagers = (managerId) =>
    `${AppConstants.MEMBER_API_HOST}/hierarchy/scope-managers?managerId=${managerId}`;